import { BaseMole } from "../BaseMole";
import { MoleAnimationController, MoleAnimationState } from "../MoleAnimationController";
import { DieState } from "./DieState";
import { FreezeState } from "./FreezeState";
import { IdleTimeoutState } from "./IdleTimeoutState";
import { IMoleState } from "./IMoleState";

export class LandingState implements IMoleState {
    private nextState: IMoleState;

    public constructor(
        private readonly mole: BaseMole,
        private readonly animationController: MoleAnimationController,
        private readonly idleState: IdleTimeoutState,
        private readonly dieState: DieState,
        private readonly freezeState: FreezeState
    ) {
        this.nextState = this;
    }

    public enter(previousState: IMoleState): void {
        this.animationController.onClipEnd.add(this.handleClipEnd, this);
        if (!(previousState instanceof FreezeState)) {
            this.animationController.transitToState(MoleAnimationState.Landing);
        }
    }

    public exit(): void {
        this.animationController.onClipEnd.remove(this.handleClipEnd, this);
    }

    public process(_dt: number): IMoleState {
        if (!this.mole.alive) {
            return this.dieState;
        }
        if (this.mole.freezed) {
            return this.freezeState;
        }
        return this.nextState;
    }

    private handleClipEnd(_state: MoleAnimationState): void {
        this.nextState = this.idleState;
    }
}